import { combineReducers } from 'redux'

import { Reducers as Api } from './Api'
import { Reducers as Messaging } from './Messaging'
import { Reducers as Controls } from '../Controls'
import { Reducers as Forms } from '../Forms'
import { Reducers as Frame } from '../Frame'
import { Reducers as Chat } from './Chat'
import { Reducers as Socket } from './Socket'
import { Reducers as Tracking } from './Tracking'

export default combineReducers({
  Api,
  Chat,
  Controls,
  Forms,
  Frame,
  Messaging,
  Socket,
  Tracking,
})
